import { SqlRbacAction } from "./action";

export type RolePrivilege = {
  privilegeType: string;
  objectType: string;
  objectName: string;
  objectCatalog?: string;
  created: string;
};

export type SqlRole<T = string> = {
  roleName: string;
  created: string;
  grantees: string[];
  privileges: T[];
  roleOwner: string;
};

export type Role = SqlRole<RolePrivilege>;

export type OrganizationRole = SqlRole<RolePrivilege>;

export enum PrivilegeObjectType {
  organization = "organization",
  account = "account",
  login = "login",
  role = "role",
  organization_role = "organization role",
  network_policy = "network policy",
  service_account = "service account",
  engine = "engine",
  database = "database",
  location = "location",
  user = "user",
  table = "table",
  view = "view",
}

export type Privilege = {
  objectType: PrivilegeObjectType;
  objectName: string;
  privilegeType: SqlRbacAction;
  owner?: string;
};
